/* global Ad */

/**
 * @param {object} state PHP varijable
 */
export default function initDates(state) {
    Ad.Datepicker.initRange(
        '#SearchPrivateFilterForm_from',
        '#SearchPrivateFilterForm_to',
        datepickerOptions(state.datepickerOptions),
    );

    initEvents();
    toggleDateDeviationCheckboxDependingOnDateRange();
}

function initEvents() {
    // Mora biti jQuery jer jQueryUI datepicker koji koristimo ne pokreće vanilla JS event.
    $('#SearchPrivateFilterForm_from, #SearchPrivateFilterForm_to').on('change', () => {
        toggleDateDeviationCheckboxDependingOnDateRange();
    });
}

function datepickerOptions(options) {
    return {
        openToAfterSelectingFromDate: true,
        allowKeyboardInput: false,
        deleteButton: { text: options.deleteText },
        currentText: options.currentText,
    };
}

/**
 * Polje 'deviation' omogućiti samo ako su oba datuma unesena.
 */
function toggleDateDeviationCheckboxDependingOnDateRange() {
    if (document.getElementById('SearchPrivateFilterForm_from').value === ''
        || document.getElementById('SearchPrivateFilterForm_to').value === ''
    ) {
        document.getElementById('SearchPrivateFilterForm_deviation').disabled = true;
    } else {
        document.getElementById('SearchPrivateFilterForm_deviation').disabled = false;
    }
}
